import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-supplier-network',
  imports: [CommonModule],
  templateUrl: './supplier-network.html',
  styleUrl: './supplier-network.scss'
})
export class SupplierNetwork {
  
  //   <script>
  //     window.addEventListener("load", function() {
  //       checkSubmit();
  //     });

  //     function checkSubmit() {
  //       const form = document.getElementById("contact-manufacturer");
  //       var name = document.getElementById('name').value;
  //       var mobile = document.getElementById('mobile').value;
  //       if (name && mobile) {
  //         document.getElementById('join-us-temp').style.display = 'none';
  //         document.getElementById('join-us').style.display = 'block';
  //       } else {
  //         document.getElementById('join-us').style.display = 'none';
  //         document.getElementById('join-us-temp').style.display = 'block';
  //       }
  //     }

  //     function formSubmit() {
  //       const form = document.getElementById("contact-manufacturer");
  //       var name = document.getElementById('name').value;
  //       var mobile = document.getElementById('mobile').value;
  //       var templateType = document.getElementById('templateType').value;
  //       var email = document.getElementById('email').value;
  //       const pageLoader = document.querySelector(".page-loader");
  //       pageLoader.classList.remove("done");
  //       if (name && mobile) {
  //         form.classList.remove("needs-validation");
  //         var dataToSend = {
  //           name: name,
  //           mobile: mobile,
  //           email: email,
  //           templateType: templateType
  //         };

  //         fetch('./assets/php/contact.php', {
  //           method: 'POST',
  //           headers: {
  //             'Content-Type': 'application/json'
  //           },
  //           body: JSON.stringify(dataToSend)
  //         }).then(response => response.json()).then(data => {
  //           pageLoader.classList.add("done");
  //           if (data.status == 200) {
  //             document.getElementById('email-success-title').innerHTML = data.msg;
  //             document.getElementById('email-success-subtitle').innerHTML = "We will call you shortly and explain the onboarding process.";
  //             document.getElementById('success-email').style.display = 'block';
  //             document.getElementById('fail-email').style.display = 'none';
  //           } else {
  //             document.getElementById('email-success-title').innerHTML = "Failed";
  //             document.getElementById('email-success-subtitle').innerHTML = data.msg;
  //             document.getElementById('success-email').style.display = 'none';
  //             document.getElementById('fail-email').style.display = 'block';
  //           }
  //           var myModal = document.getElementById('modal-email');
  //           var modal = new bootstrap.Modal(myModal);
  //           modal.show();
  //         }).catch(error => console.error('Error:', error));
  //       } else {
  //         form.submit();
  //       }
  //     }

  //     function redirectHome() {
  //       window.location.href = "/index.html";
  //     }
    
  //   function filterContent(){
  //       var filter = document.getElementById('garage').value;
  //       var items = document.querySelectorAll('.Garage-list .card');
  //       items.forEach(function(item) {
  //           if (filter === 'all' || item.querySelector('.content-item').getAttribute('data-category') === filter) {
  //               item.style.display = 'block';
  //           } else {
  //               item.style.display = 'none';
  //           }
  //       });
  //   }
  //   function filterLocationContent(){
  //       var filter = document.getElementById('location').value;
  //        var items = document.querySelectorAll('.Garage-list .card');
  //       //  console.log(items)
  //        items.forEach(function(item) {
  //         // console.log(item)
  //           if (filter === 'all' || item.querySelector('.content-item').getAttribute( 'data-location') === filter) {
  //               item.style.display = 'block';
  //           } else {
  //               item.style.display = 'none';
  //            }
  //        });
  //   }
  // </script>
  // <script>
  //   // Reset the form when the modal is closed
  //   document.getElementById('modal-join-us').addEventListener('hidden.bs.modal', function () {
  //     document.getElementById('contact-manufacturer').reset();
  //   });
  // </script>
  // <script>
  //   document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  //     anchor.addEventListener('click', function (e) {
  //       e.preventDefault();
        
  //       document.querySelector(this.getAttribute('href')).scrollIntoView({
  //         behavior: 'smooth'
  //       });
  //     });
  //   });
  // </script>


  // <script type="application/ld+json">
  //   {
  //     "@context": "https://schema.org",
  //     "@type": "Organization",
  //     "name": "Autoverse Mobility",
  //     "url": "https://www.autoversemobility.in",
  //     "logo": "https://www.autoversemobility.in/images/logo.png",
  //     "contactPoint": {
  //       "@type": "ContactPoint",
  //       "telephone": "8884998600",
  //       "contactType": "Customer Service",
  //       "contactOption": "TollFree", 
  //       "areaServed": "IN"
  //     },
  //     "sameAs": [
  //       "https://www.linkedin.com/company/autoverse-mobility",
  //       "https://twitter.com/autoversemobility"
  //     ]
  //   }
  //   </script>
}
